import React from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import CTABand from "@/components/CTABand";
import { testimonials } from "@/data/testimonials";

const JOURNEY_LABELS = [
  ["lookingFor", "What they were looking for"],
  ["unsure", "What they were unsure about"],
  ["helped", "How ACRE helped"],
  ["nextStep", "What the next step became"],
];

const ClientStories = () => (
  <div data-testid="client-stories-page">
    <SEO
      title="Client Stories — ACRE"
      description="Real journeys from ACRE clients: London and New Jersey-based families, Mumbai developer groups and global investors buying across Dubai, Abu Dhabi and Al Marjan Island."
      path="/client-stories"
      keywords="Dubai property investment for UK buyers, buying property in Dubai as a UK citizen"
    />
    <PageHero
      eyebrow="Client Stories"
      title="Journeys, not transactions"
      intro="Fourteen clients, fourteen different starting points. What they share is a preference for being advised rather than sold to."
      testid="client-stories-hero"
    />
    <section className="pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-6" data-testid="client-stories-grid">
        {testimonials.map((t, i) => (
          <Reveal key={t.id} delay={(i % 2) * 0.08}>
            <article className="card-hover h-full bg-[#13151D] border border-[rgba(197,168,128,0.15)] rounded-2xl p-8" data-testid={`story-${t.id}`}>
              <blockquote className="font-display text-2xl italic text-[#F4F3EF] leading-relaxed mb-2">“{t.quote}”</blockquote>
              <p className="text-xs text-[#C5A880] uppercase tracking-[0.15em] mb-8">{t.name} · {t.meta}</p>
              <dl className="space-y-5">
                {JOURNEY_LABELS.map(([key, label]) => (
                  <div key={key}>
                    <dt className="text-[10px] uppercase tracking-[0.2em] text-[#6b7280] mb-1.5">{label}</dt>
                    <dd className="text-sm text-[#9DA3AE] font-light leading-relaxed">{t.journey[key]}</dd>
                  </div>
                ))}
              </dl>
            </article>
          </Reveal>
        ))}
      </div>
      <p className="text-center text-[11px] text-[#6b7280] font-light mt-12 max-w-xl mx-auto">
        Client identities are anonymised for privacy. Stories are shared with permission and reflect individual
        experiences; outcomes vary by circumstance.
      </p>
    </section>
    <CTABand testid="client-stories-cta" title="Write your own chapter." subtitle="Every story on this page began with a single private conversation." />
  </div>
);

export default ClientStories;
